import { FC } from 'react';
import { Form } from '@repo-level/core-front';

import { FormGroup } from 'components/form/groups/FormGroup';
import { Input } from 'components/form/Input';
import { OfUnion } from 'types/common';

export const FieldPassword: FC<
  OfUnion<Form.MethodField>[Form.MethodFieldType.Password]
> = ({ fieldName, label }) => (
  <FormGroup title={label || fieldName}>
    <Input field={fieldName} type="password" />
  </FormGroup>
);
